module.exports = __webpack_public_path__ + "img/baac.d2fdd66b.png";